const MAX_VISIBLE_ROWS = 2;
const TO_LIST = 3;

export function onLeft() {
  if (this.state.colIndex > 0) {
    this.setState(
      {
        colIndex: this.state.colIndex - 1
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false
        })
    );
  } else if (this.state.colIndex === 0) {
    if (this.props.currentView === 0) {
      this.setState(
        {
          colIndex: this.state.colIndex
        },
        () =>
          this.props.onChange({
            rowIndex: this.state.rowIndex,
            colIndex: this.state.colIndex,
            categoryIndex: this.state.categoryIndex,
            changeView: true,
            showRows: this.showRows,
            showCat: this.showCat,
            currentRowIndex: this.state.currentRowIndex,
            wheelState: this.wheelState
          })
      );
    } else if (this.props.currentView === 1) {
      this.setState(
        {
          colIndex: -1
        },
        () =>
          this.props.onChange({
            rowIndex: this.state.rowIndex,
            colIndex: this.state.colIndex,
            categoryIndex: this.state.categoryIndex,
            changeView: false
          })
      );
    }
  }
}

export function onRight(totalRowItems) {
  if (this.props.currentView === 0 && this.props.backToCetaogryColIndex === -1) {
    this.setState(
      {
        colIndex: 0
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          showRows: this.showRows,
          showCat: this.showCat,
          currentRowIndex: this.state.currentRowIndex
        })
    );
    return;
  }

  if (this.state.colIndex < totalRowItems - (this.props.currentView === 0 ? 2 : 1)) {
    this.setState(
      {
        colIndex: this.state.colIndex + 1
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false
        })
    );
  } else if (this.props.currentView === 0 && this.state.colIndex === totalRowItems - 2) {
    this.setState(
      {
        colIndex: this.state.colIndex
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: true,
          showRows: this.showRows,
          showCat: this.showCat,
          currentRowIndex: this.state.currentRowIndex,
          wheelState: this.wheelState
        })
    );
  }
}

export function onDown(totalRows, totalCat) {
  if (this.state.colIndex > -1) {
    //limits
    if (totalRows >= MAX_VISIBLE_ROWS && this.state.rowIndex < totalRows - 1) {
      if (this.state.currentRowIndex > -1 && this.state.currentRowIndex < MAX_VISIBLE_ROWS - 1) {
        this.setState({
          currentRowIndex: this.state.currentRowIndex + 1
        });
      } else if (this.showRows.to <= totalRows && this.state.currentRowIndex === MAX_VISIBLE_ROWS - 1) {
        this.showRows.to += 1;
        this.showRows.from += 1;
      }
    } else if (this.state.rowIndex === totalRows - 1) {
      if (totalCat > 1 && this.state.categoryIndex < totalCat - 1) {
        this.showCat.to += 1;
        this.showCat.from += 1;
        this.showRows.to = TO_LIST;
        this.showRows.from = 0;
      }
    }
    //states
    if (this.state.rowIndex < totalRows - 1) {
      this.setState(
        {
          rowIndex: this.state.rowIndex + 1
        },
        () =>
          this.props.onChange({
            rowIndex: this.state.rowIndex,
            colIndex: this.state.colIndex,
            categoryIndex: this.state.categoryIndex,
            changeView: false
          })
      );
    } else if (this.state.rowIndex === totalRows - 1 && this.state.categoryIndex < totalCat - 1) {
      if (totalCat > 1) {
        this.setState(
          {
            rowIndex: 0,
            currentRowIndex: 0,
            categoryIndex: this.state.categoryIndex + 1
          },
          () =>
            this.props.onChange({
              rowIndex: this.state.rowIndex,
              colIndex: this.state.colIndex,
              categoryIndex: this.state.categoryIndex,
              changeView: false
            })
        );
      }
    }
  }
}

export function onUp(totalRows, totalCat, perviousCatTotalRows) {
  //limits
  if (this.state.colIndex > -1) {
    if (this.state.rowIndex > 0) {
      if (this.state.currentRowIndex > 0) {
        this.setState({
          currentRowIndex: this.state.currentRowIndex - 1
        });
      } else if (this.state.currentRowIndex === 0) {
        this.showRows.to = this.showRows.to !== MAX_VISIBLE_ROWS + 1 ? this.showRows.to - 1 : MAX_VISIBLE_ROWS + 1;
        this.showRows.from = this.showRows.from !== 0 ? this.showRows.from - 1 : 0;
      }
    } else if (this.state.rowIndex === 0) {
      if (totalCat > 1 && this.state.categoryIndex > 0) {
        this.showCat.to -= 1;
        this.showCat.from -= 1;
        this.showRows.from = perviousCatTotalRows > MAX_VISIBLE_ROWS + 1 ? perviousCatTotalRows - TO_LIST : 0;
        this.showRows.to = perviousCatTotalRows > MAX_VISIBLE_ROWS + 1 ? perviousCatTotalRows : MAX_VISIBLE_ROWS + 1;
      }
    }
    //states
    if (this.state.rowIndex > 0) {
      this.setState(
        {
          rowIndex: this.state.rowIndex - 1
        },
        () =>
          this.props.onChange({
            rowIndex: this.state.rowIndex,
            colIndex: this.state.colIndex,
            categoryIndex: this.state.categoryIndex,
            changeView: false
          })
      );
    } else if (this.state.rowIndex === 0) {
      if (totalCat > 1 && this.state.categoryIndex > 0) {
        this.setState(
          {
            rowIndex: perviousCatTotalRows - 1,
            currentRowIndex:
              perviousCatTotalRows > 1
                ? perviousCatTotalRows - 1 >= MAX_VISIBLE_ROWS
                  ? MAX_VISIBLE_ROWS
                  : MAX_VISIBLE_ROWS - 1
                : 0,
            categoryIndex: this.state.categoryIndex - 1
          },
          () =>
            this.props.onChange({
              rowIndex: this.state.rowIndex,
              colIndex: this.state.colIndex,
              categoryIndex: this.state.categoryIndex,
              changeView: false,
              showRows: this.showRows,
              showCat: this.showCat
            })
        );
      }
    }
  }
}
